import { saveAttachment, readAttachment, deleteAttachment } from "./db";

export const OFFLINE_ATTACHMENT_RESOURCE = "document-upload";

export type OfflineAttachmentInfo = {
  id: string;
  fileName: string;
  contentType: string;
  size: number;
};

const buildAttachmentId = () => `offline-doc-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const createOfflineAttachment = async (file: File): Promise<OfflineAttachmentInfo> => {
  const id = buildAttachmentId();
  const fileName = file.name?.trim().length ? file.name : "Document";
  const contentType = file.type || "application/octet-stream";
  const size = typeof file.size === "number" ? file.size : 0;
  const buffer = await file.arrayBuffer();
  await saveAttachment({
    id,
    resource: OFFLINE_ATTACHMENT_RESOURCE,
    mimeType: contentType,
    data: buffer,
    createdAt: Date.now(),
    metadata: {
      fileName,
      size,
    },
  });
  return {
    id,
    fileName,
    contentType,
    size,
  };
};

export const readOfflineAttachment = async (id: string) => readAttachment(id);

export const deleteOfflineAttachment = async (id: string) => deleteAttachment(id);
